module.exports = __webpack_public_path__ + "static/media/w_w_hr_18.7c14ae0b.png";